import { SearchByType } from "../../../../models/enums/search-by-type";
import { PageData } from "../../../../models/utilities/paged-request";
import { SearchGroupModel } from "../../../../models/utilities/search-group-model";
import { ISearchBarParameters } from "../../../../models/utilities/searchbar-parameters";
import { MailJobTypes } from "../../../../models/utilities/type-models";
import { ApiEndpoints, GlobalConstants } from "../../../../utils/app-constants";

export class MailJobSearchParams implements ISearchBarParameters {
    
    // Required Properties
    public paginationInfo       : PageData;
    public selectedSearchType   : string = '';
    public searchFields         : SearchGroupModel[];

    // Search Properties
    public status       : string = '';
       
    // Search Property Names
    public STATUS           = 'status';

    constructor(type: MailJobTypes) {
        this.paginationInfo = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
        this.status = type;
        this.searchFields = [
            new SearchGroupModel(this.STATUS, SearchByType.STATIC_INPUT, "STATUS", type, true, true)
        ];
    }

    /**
     * Return a plain object with the proper fields and values
     */
    public toSearchObject() {
        const obj : any = {};
        obj[this.STATUS] = this.status;

        return obj;
    }

    /**
     * Based on the instances properties, return a URL to search
     */
    public toUrl() {
         
        let url = ApiEndpoints.COMMUNICATION_MAILJOB_QUERY.formattify(this.status);

        // Juuust in case.
        if (this.paginationInfo.skip < 0) { this.paginationInfo.skip = 0; }
        if (this.paginationInfo.take <= 0) { this.paginationInfo.take = 100; }

        url += `&skip=${this.paginationInfo.skip}&take=${this.paginationInfo.take}`;

        return url;
    }

    /**
     * Based on the properties and selected option, check if the right properties
     * are filled in
     */
    public isValid() {
        return true;
    }
}
